<div class="content-wrapper">

  @if (showView) {
    <div class="properties-container">
      @for (audioFileProperty of audioFileProperties; track audioFileProperty) {
        @if (showProperty(trackInfoOverlayData.track, audioFileProperty)) {
          <div class="property">
            <div class="frontLabel">{{labelForProperty(audioFileProperty)}}</div>
            <tun-scrollable-text class="valueLabel" [text]="valueForProperty(trackInfoOverlayData.track, audioFileProperty)"></tun-scrollable-text>
          </div>
        }
      }
    </div>
  }

  @if (showView) {
    <div class="action-container">
      <!-- remove from playlist -->
      @if (removeFromPlaylistActionAvailable) {
        <button class="action-button" (click)="onRemoveFromPlaylist()">
          <tun-delete-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-delete-icon-v5 > {{'trackOptions.list.remove' | translate}}
        </button>
      }
      <!-- remove from favorite (only from favorite list) -->
      @if (removeFromFavoriteActionAvailable) {
        <button class="action-button" (click)="onRemoveFromPlaylist()">
          <tun-delete-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-delete-icon-v5 > {{'trackOptions.favorite.remove' | translate}}
        </button>
      }
      <!-- remove from queue (only from queue) -->
      @if (removeFromQueurAvailable) {
        <button class="action-button" (click)="onRemoveFromQueue()">
          <tun-delete-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-delete-icon-v5 > {{'trackOptions.queue.remove' | translate}}
        </button>
      }
      <!-- toggle favorite -->
      @if (toggleFavoriteActionAvailable) {
        <button class="action-button" (click)="onToggleFavorite()">
          @if (!isFavorite) {
            <tun-thumb-up-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-thumb-up-icon-v5 >
          }
          @if (isFavorite) {
            <tun-thumb-up-active-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-thumb-up-active-icon-v5 >
          }
          {{(isFavorite ? 'trackOptions.favorite.remove' : 'trackOptions.favorite.add') | translate}}
        </button>
      }
      <!-- toggle banned -->
      @if (toggleBannedActionAvailable) {
        <button class="action-button" (click)="onToggleBanlist()">
          @if (!isBanned) {
            <tun-thumb-down-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-thumb-down-icon-v5 >
          }
          @if (isBanned) {
            <tun-thumb-down-active-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-thumb-down-active-icon-v5 >
          }
          {{((favBannedTrack.trackIsBanned$ | async) ? 'trackOptions.banned.remove' : 'trackOptions.banned.add') | translate}}
        </button>
      }
      <!-- add to playlist -->
      @if (addToPlaylistAvailable) {
        <button class="action-button {{ (customPlaylistsEnabled$ | async) ? '' : 'disabled-action'}}" (click)="onAddToPlaylist()">
          <tun-add-to-playlist-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-add-to-playlist-v5>{{'trackOptions.playlist.add' | translate}}
        </button>
      }
      <!-- toggle queue -->
      @if (toggleQueueAvailable) {
        <button class="action-button {{ (addToQueueEnabled$ | async) ? '' : 'disabled-action'}}" (click)="onToggleQueue()">
          @if (!trackIsInQueue) {
            <tun-add-to-queue-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-add-to-queue-v5 >
          }
          @if (trackIsInQueue) {
            <tun-queue-full-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-queue-full-icon-v5>
          }
          {{(trackIsInQueue ? 'trackOptions.queue.remove' : 'trackOptions.queue.add') | translate}}
        </button>
      }
      <button class="action-button {{ (searchEnabled$ | async) ? '' : 'disabled-action'}}" (click)="onSearchArtist()">
        <tun-search-result-artist-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-search-result-artist-icon-v5 > {{'trackOptions.search.artist' | translate}}
      </button>
      <button class="action-button {{ (searchEnabled$ | async) ? '' : 'disabled-action'}}" (click)="onSearchTitle()">
        <tun-search-result-song-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-search-result-song-icon-v5 > {{'trackOptions.search.title' | translate}}
      </button>
      <button class="action-button {{ (searchEnabled$ | async) ? '' : 'disabled-action'}}" (click)="onSearchSimilar()">
        <tun-menu-search-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-menu-search-icon-v5 > {{'trackOptions.search.similar' | translate}}
      </button>
      @for (audioFileProperty of audioFileProperties; track audioFileProperty) {
        @if (showPropertySearch(trackInfoOverlayData.track, audioFileProperty)) {
          <button class="action-button {{ (searchEnabled$ | async) ? '' : 'disabled-action'}}" (click)="onSearchProperty(audioFileProperty)">
            <tun-menu-search-icon-v5 class="icon icon-scaled-svg-button icon-action-button"></tun-menu-search-icon-v5 > {{searchTextForProperty(trackInfoOverlayData.track, audioFileProperty)}}
          </button>
        }
      }
    </div>
  }

</div>
